export const hasUserListed = (lutItem, customerId, msisdn) => {
    var _a, _b, _c, _d;
    let result = false;
    if (customerId && customerId !== 0) {
        result = (_b = (_a = lutItem.whitelisted_cdbIds) === null || _a === void 0 ? void 0 : _a.some(i => i === String(customerId))) !== null && _b !== void 0 ? _b : false;
    }
    if (msisdn) {
        result = result || ((_d = (_c = lutItem.whitelisted_msisdns) === null || _c === void 0 ? void 0 : _c.some(i => i === msisdn)) !== null && _d !== void 0 ? _d : false);
    }
    return result;
};
